import React from "react";
import { useAppContext } from "@/context/Context";
import DarkSwitch from "./dark-switch"; // Ensure correct path

function Dark() {
  const { isLightTheme, toggleTheme } = useAppContext();

  return (
    // Add fixed positioning to this wrapper div
    <div
      style={{
        position: "fixed",
        bottom: "30px", // Same bottom as WhatsApp button
        left: "30px", // Position on the left side
        zIndex: 1000, // Ensure it's above other content
      }}
      className="d-flex align-items-center justify-content-center" // Keep for centering DarkSwitch
      aria-label="Theme toggle button container" // Good for accessibility
    >
      <DarkSwitch isLight={isLightTheme} switchTheme={toggleTheme} />
    </div>
  );
}

export default Dark;
